import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { useLocation } from '@xing-com/crate-core-router';
import type { PlayerApi, PlayerProps } from '@xing-com/crate-video-player';
import { Player } from '@xing-com/crate-video-player';

type Props = {
  configuration: PlayerProps['configuration'];
};
export const PlayerView: FC<Props> = ({ configuration }) => {
  const { search } = useLocation();

  const searchParams = new URLSearchParams(search);

  const [iframeId] = useState(searchParams.get('id'));
  const [videoId] = useState(searchParams.get('video_id'));
  const [section] = useState(searchParams.get('section') ?? 'unkownn');
  const [playerActions, setPlayerAction] = useState<PlayerApi | null>(null);

  const messageHandler = (event: MessageEvent): void => {
    let message;

    try {
      message = JSON.parse(event.data);
    } catch {
      return;
    }
    if (message.type !== 'api') {
      return;
    }

    switch (message.data.action) {
      case 'play':
        playerActions?.play(message.data.params[0], message.data.params[1]);
        break;
      case 'pause':
        playerActions?.pause(message.data.params[0]);
        break;
      case 'setMute':
        playerActions?.setMute(
          message.data.params[0] !== null ? message.data.params[0] : undefined
        );
        break;
      case 'setVolume':
        playerActions?.setVolume(message.data.params[0]);
        break;
    }
  };

  const triggerEvent = (
    event: { name: string; mute?: boolean },
    id: string | null
  ): void => {
    const data = {
      type: 'xing_video_event',
      event,
      id,
    };

    window.parent.postMessage(JSON.stringify(data), '*');
  };

  useEffect(() => {
    window.addEventListener('message', (e) => messageHandler(e));
  }, []);

  return (
    <>
      <Helmet>
        <style type="text/css">
          {`
              html {
                overflow: hidden;
              }

              body {
                padding: 0;
                margin: 0;
              };
            `}
        </style>
      </Helmet>
      <Player
        id={videoId || '44'}
        section={section}
        actions={(playerApi) => setPlayerAction(playerApi)}
        configuration={configuration}
        onReady={() => triggerEvent({ name: 'ready' }, iframeId)}
        onMute={(val) => triggerEvent({ name: 'mute', mute: val }, iframeId)}
        onPlay={() => triggerEvent({ name: 'play' }, iframeId)}
        onPause={() => triggerEvent({ name: 'pause' }, iframeId)}
        onComplete={() => triggerEvent({ name: 'complete' }, iframeId)}
        onError={() => triggerEvent({ name: 'error' }, iframeId)}
      />
    </>
  );
};
